import type { Observable } from 'rxjs';

import { createProviderToken } from '@core/common-legacy';

export interface AppContextCollector {
  readonly key: string;
  snapshot: () => unknown;
  readonly changes$?: Observable<unknown>;
}

export interface AppContextRedactor<T> {
  redact: (ctx: T) => T;
}

export const { provide: provideTellentContextCollector, inject: injectTellentContextCollectors } =
  createProviderToken<AppContextCollector>('TELLENT_APP_CONTEXT_COLLECTORS')(true);

export const { provide: provideTellentContextRedactor, inject: injectTellentContextRedactor } =
  createProviderToken<AppContextRedactor<unknown>>('TELLENT_APP_CONTEXT_REDACTOR')(false);
